import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=502aab1b&"
import script from "./ChangePass.vue?vue&type=script&lang=js&"
export * from "./ChangePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports